import { getAll } from '@/api/utilisateur/index';

function getRole(roles) {
  let roleUtilisateur = '';
  roles.forEach((role) => {
    roleUtilisateur += role.displayName + ', ';
  });
  return roleUtilisateur.substr(0, roleUtilisateur.length - 2);
}

export default async function getListeUtilisateur() {
  const response = await getAll();
  response.data.result.forEach((utilisateur) => {
    utilisateur.logo = null;
    utilisateur.role = getRole(utilisateur.objetsRoles);
    utilisateur.logoCharge = false;
  });
  return response.data.result;
}
